import { render, staticRenderFns } from "./IHASCO.vue?vue&type=template&id=4b590ce1&scoped=true&"
import script from "./IHASCO.vue?vue&type=script&lang=js&"
export * from "./IHASCO.vue?vue&type=script&lang=js&"
import style0 from "./IHASCO.vue?vue&type=style&index=0&id=4b590ce1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b590ce1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
